<div class="Footer_bottom">
  <section>
  <div class="text-right mb-2">
    <button mat-icon-button (click)="openLogoutDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  </section>
</div>
